exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#generateRaport .values-list__element{padding-top:5px;padding-bottom:5px;border-bottom:1px solid #d3d3d3;display:flex;justify-content:flex-start;line-height:32px}#generateRaport *{font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8ced9b00","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/analysis/modals/GenerateRaport.vue
// module id = 1749
// module chunks = 0